/* eslint-disable react/prop-types */
import classNames from 'classnames'
import Block from 'components/Block'
import style from 'components/ContentBlocks.module.scss'
import ContentPanel from 'components/ContentPanel'
import Headings from 'components/Headings'
import IconGrid from 'components/IconGrid'
import IconStrip from 'components/IconStrip'
import PagePreviews from 'components/PagePreviews'
import ResourceGroup from 'components/ResourceGroup'
import SingleImage from 'components/SingleImage'
import Slider from 'components/Slider'
import camelCase from 'lodash/camelCase'
import React from 'react'

const ContentBlocks = ({ contentBlocks }) => {
  if (!contentBlocks) return null

  const Component = ({ block }) => {
    switch (block.__typename) {
      case 'ContentfulEdCarousels': {
        return <div className={style.inDevelopment}>{block.__typename}</div>
      }
      case 'ContentfulEdContentPanels': {
        return (
          <ContentPanel
            image={block.image}
            heading={block.title}
            imagePosition={camelCase(block.imagePosition)}
            text={block.text?.text}
            action={{ label: block.actionLabel, url: block.actionUrl }}
            color={block.color}
            backgroundColor={block.backgroundColor}
          />
        )
      }
      case 'ContentfulEdHeadings': {
        return (
          <Headings
            mainHeading={block.mainHeading}
            subHeading={block.subHeading?.subHeading}
          />
        )
      }
      case 'ContentfulEdIconGrids': {
        return <IconGrid heading={block.title} icons={block.icons} />
      }
      case 'ContentfulEdIconStrips': {
        return (
          <IconStrip
            items={block.items}
            backgroundColor={block.backgroundColor}
            actionLabel={block.actionLabel}
            actionUrl={block.actionUrl}
          />
        )
      }
      case 'ContentfulEdPagePreviews': {
        return <PagePreviews heading={block.title} pages={block.pages} />
      }
      case 'ContentfulEdResourceGroups': {
        return (
          <ResourceGroup
            resources={block.resources}
            theme={block.backgroundColor === 'None' ? 'dark' : 'light'}
          />
        )
      }
      case 'ContentfulEdSingleImages': {
        return (
          <SingleImage
            image={block.image}
            highlightPosition={block.highlightPosition}
            highlightColor={block.highlightColor}
            backgroundColor={block.backgroundColor}
          />
        )
      }
      case 'ContentfulEdSliders': {
        return (
          <Slider cells={block.cells} backgroundColor={block.backgroundColor} />
        )
      }

      default:
        return (
          <div className={style.inDevelopment}>
            Page component {block.__typename}
          </div>
        )
    }
  }

  return (
    <div className={style.root}>
      {contentBlocks.map(block => {
        const blockType = camelCase(block.__typename)

        const className = classNames(
          style.block,
          style[`block___backgroundColor_${camelCase(block.backgroundColor)}`],
          style[`block___type_${blockType}`],
          { [style.block___showBottomBorder]: block.showBottomBorder }
        )

        return (
          <div key={block.id} className={className}>
            <Block
              key={block.id}
              backgroundColor={block.backgroundColor}
              type={blockType}
            >
              <Component block={block} />
            </Block>
          </div>
        )
      })}
    </div>
  )
}

ContentBlocks.defaultProps = {}

export default ContentBlocks
